import { __, sprintf } from '@wordpress/i18n';
import type { DayPickerProps } from 'react-day-picker';

/**
 * Translatable ARIA labels for react-day-picker, which ships hardcoded English defaults.
 */
export const dayPickerLabels: DayPickerProps['labels'] = {
	labelNext: () => __('Go to the Next Month', 'gp-bookings'),
	labelPrevious: () => __('Go to the Previous Month', 'gp-bookings'),
	labelMonthDropdown: () => __('Choose the Month', 'gp-bookings'),
	labelYearDropdown: () => __('Choose the Year', 'gp-bookings'),
	labelWeekNumberHeader: () => __('Week Number', 'gp-bookings'),
	labelWeekNumber: (weekNumber) =>
		/* translators: %d: week number */
		sprintf(__('Week %d', 'gp-bookings'), weekNumber),
	labelDayButton: (date, modifiers, options, dateLib) => {
		let label = dateLib
			? dateLib.format(date, 'PPPP')
			: date.toLocaleDateString(options?.locale?.code, {
					dateStyle: 'full',
				});
		if (modifiers.today) {
			/* translators: %s: formatted date */
			label = sprintf(__('Today, %s', 'gp-bookings'), label);
		}
		if (modifiers.selected) {
			/* translators: %s: formatted date */
			label = sprintf(__('%s, selected', 'gp-bookings'), label);
		}
		return label;
	},
};
